
import { useState } from 'react';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How long does the process typically take?',
      answer: 'The timeline varies depending on the complexity of your business and your specific situation. From initial conversation to closing, the process typically takes 3-6 months. However, we work at your pace and can accommodate faster or slower timelines as needed.'
    },
    {
      question: 'What kind of deal terms do you offer?',
      answer: 'We offer flexible deal structures tailored to your needs. This can include cash at closing, seller financing, earnouts, or hybrid arrangements. Our goal is to structure a deal that works for your financial goals and risk tolerance.'
    },
    {
      question: 'What happens to my employees?',
      answer: 'Protecting your team is one of our top priorities. We typically maintain existing employment and often create new opportunities as the business grows. We believe that your employees are a key asset and treat them accordingly.'
    },
    {
      question: 'Do you require seller financing?',
      answer: 'Not necessarily. While seller financing can be part of a deal structure, we have the flexibility to structure transactions in various ways. We discuss all options during our evaluation process.'
    },
    {
      question: 'How do you determine the value of my business?',
      answer: 'Our valuation process considers multiple factors: financial performance, market position, growth potential, operational efficiency, and intangible assets like customer relationships and brand value. We use industry-standard methodologies combined with our extensive experience.'
    },
    {
      question: 'What if I change my mind during the process?',
      answer: 'You can withdraw from discussions at any time before signing a definitive agreement. We understand this is a major decision, and we respect your right to change your mind. There are no penalties for deciding not to proceed.'
    }
  ];

  return (
    <section className="py-20 bg-soft-gray">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl font-bold text-navy mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Here are answers to some common questions we hear from business owners.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden">
              <button
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200"
              >
                <h3 className="font-semibold text-navy pr-4">{faq.question}</h3>
                <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-[#C9A227] text-xl flex-shrink-0`}></i>
              </button>
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Have other questions?</p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="btn-primary"
          >
            Schedule a Call to Discuss
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
